import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'libraries/ui_card/card.module';
import { MenuDetailsModule } from 'libraries/hotel/components/menu-details/menu-details.module';
import { RemarksModule } from './components/remarks/remarks.module';
import { BookingRemarksComponent } from './booking-remarks.component';
import { OsiModule } from './components/osi/osi.module';
import { ButtonModule } from "libraries/module/formbuilder/fields/button/button.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { NotepadModule } from 'libraries/component/notepad/notepad.module';
import { VendorAlertsComponent } from './components/vendor-alerts/vendor-alerts.component';
import {DatePipeModule} from "../../../../date/date.module";
import {MatTableModule} from "@angular/material/table";

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        MenuDetailsModule,
        RemarksModule,
        OsiModule,
        ButtonModule,
        BtnModule,
        NotepadModule,
        LoaderModule,
        NotificationModule,
        DatePipeModule,
        MatTableModule
    ],
    exports: [
        BookingRemarksComponent
    ],
    declarations: [
        BookingRemarksComponent,
        VendorAlertsComponent
    ],
})
export class BookingRemarksModule { }
